const CORE_MODULES = [	
	'textAngular',
	'textAngularSetup',
	'ngAnimate',
	'toaster',											
	'formly', 
	'formlyBootstrap',
	'ui.bootstrap',
	'nya.bootstrap.select',
	'mgcrea.ngStrap.affix'
	// 'pascalprecht.translate'	
];

export default angular
								.module('easyFormGen.dragDropWay.core', CORE_MODULES);



// WEBPACK FOOTER //
// ./src/app/dragdropway/core/edaDragDropWay.core.module.js